<!--
 * @Author: mazhigang
 * @Date: 2023-09-02 22:16:19
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-11-05 19:00:40
-->
<template>
  <div style="background: #FAFCFF;overflow-x: scroll;">
    <div class="pageTop">
      <img src="../../../static/bannernew.jpg" alt="" style="width: 100%;" />
      <div
        :class="[bgcolor == 0 ? 'activeBg' : '']"
        style=" width: 100%; position: fixed;top: 0;left: 0;z-index: 999;"
      >
        <pageTop :color="bgcolorstring"></pageTop>
      </div>
    </div>
    <div class="itemBox">
      <div class="boxTitle">
        <img
          src="../../../static/titleIcon.png"
          alt=""
          style="width: 31px;height: 25px;z-index: 9;margin-right: 10px;margin-top: 4px;"
        />
        <div>AI警保协同平台，最小作战单元</div>
      </div>
      <div class="boxTitle1">
        公安-企业-保安八级联动，聚焦应急与反恐实战，从协同联动到全域治理，让每一份安保力量都在掌控之中。
        重点突发事件、重大警情，警情快速响应|减少警力投入，任务闭环处置|跨部门协调。
      </div>
      <swiper :items="arr1" :duration="60" :item-width="280" :gap="20"></swiper>
    </div>
    <div class="bigBg">
      <div class="itemBox1">
        <div class="boxTitle">
          <img
            src="../../../static/titleIcon.png"
            alt=""
            style="width: 31px;height: 25px;z-index: 9;margin-right: 10px;margin-top: 4px;"
          />
          <div>面向万人级大型活动的数字化管控平台</div>
        </div>
        <div class="boxTitle1">
          面向公安机关及治安监管需求，服务演唱会、足球赛等万人级活动。构建从事前资质预审到事中勤务调度、事后溯源复盘的一体化数字管控体系。
        </div>
        <swiper
          :items="arr2"
          :duration="60"
          :item-width="280"
          :gap="20"
        ></swiper>
        <!-- <div style="position: relative;">
          <div class="downloadApp">
            立即注册认证，解锁海量保安岗位 >>
          </div>
          <div class="down-semicircle" style="left: 32%;"></div>
          <img
            src="../../../static/baoan.png"
            alt=""
            class="downUser"
            style="left: 46%;"
          />
          <div class="downText" style="left: 46%;">扫码下载咖德安保APP</div>
        </div> -->
      </div>
    </div>
    <div class="itemBox">
      <div class="boxTitle">
        <img
          src="../../../static/titleIcon.png"
          alt=""
          style="width: 31px;height: 25px;z-index: 9;margin-right: 10px;margin-top: 4px;"
        />
        <div>面向保安服务企业打造的一体化智慧保安管理平台</div>
      </div>
      <div class="boxTitle1">
        三大终端架构由 SaaS 管理后台、指挥大屏、保安 APP
        协同组成，数据实时互通；覆盖人员项目管控、考勤事件处置、薪资通知管理全业务链路，打通信息孤岛
      </div>
      <swiper :items="arr3" :duration="60" :item-width="280" :gap="20"></swiper>
      <!-- <div style="position: relative;">
        <div class="downloadApp">
          保安多，响应快，马上去发布招聘岗位 >>
        </div>
        <div class="down-semicircle"></div>
        <img src="../../../static/user.png" alt="" class="downUser" />
        <div class="downText">扫码下载咖德APP</div>
      </div> -->
    </div>
    <div class="bigBg" style="position: relative;">
      <div class="itemBox1">
        <div class="boxTitle">
          <img
            src="../../../static/titleIcon.png"
            alt=""
            style="width: 31px;height: 25px;z-index: 9;margin-right: 10px;margin-top: 4px;"
          />
          <div>专注安保行业全场景招聘平台</div>
        </div>
        <div class="boxTitle1">
          精准定位安保垂直领域，覆盖长勤、临勤用工需求；搭建企业 APP、保安
          APP、小程序三端联动生态，实现人岗精准匹配，双向实名认证，提升安保行业用工规范化。
        </div>
        <swiper
          :items="arr4"
          :duration="60"
          :item-width="280"
          :gap="20"
        ></swiper>
        <!-- <div style="position: relative;">
          <div class="downloadApp">
            立即注册认证，解锁海量保安岗位 >>
          </div>
          <div class="down-semicircle" style="left: 32%;"></div>
          <img
            src="../../../static/baoan.png"
            alt=""
            class="downUser"
            style="left: 46%;"
          />
          <div class="downText" style="left: 46%;">扫码下载咖德安保APP</div>
        </div> -->
      </div>
      <img
        src="../../../static/leftCode.png"
        alt=""
        style="width: 146px;position: absolute;right: 0;top: 50%;transform: translateY(-50%);"
      />
    </div>
    <!-- <div>
      <img src="../../../static/modelImg.png" alt="" style="width: 100%;" />
    </div> -->
    <div class="itemBox" style="margin-bottom: 0;">
      <div
        style="display: flex;width: 100%;text-align: center;justify-content: center;align-items: center;"
      >
        <div>
          <img
            src="../../../static/leftms.png"
            alt=""
            style="width: 52px;height: 110px;"
          />
        </div>
        <div>
          <div class="boxTitle">
            <img
              src="../../../static/titleIcon.png"
              alt=""
              style="width: 31px;height: 25px;z-index: 9;margin-right: 10px;margin-top: 4px;"
            />
            <div>自主创新与技术实力：核心软件著作权认证</div>
          </div>
          <div class="boxTitle1">
            咖德蔚来拥有多项自主研发的软件著作权，涵盖智能调度、人员匹配、现场管理等核心功能模块，实现安保服务的数字化、智能化升级，形成核心技术支撑体系，为平台持续优化服务、拓展市场提供强有力的知识产权保障。
          </div>
        </div>
        <div>
          <img
            src="../../../static/rightms.png"
            alt=""
            style="width: 52px;height: 110px;"
          />
        </div>
      </div>
      <swiper1
        :items="arr5"
        :duration="60"
        :item-width="225"
        :gap="15"
      ></swiper1>
    </div>
    <div class="bottonBg">
      <div class="qiye">
        <div class="boxTitle">
          <div>企业合作</div>
        </div>
        <div style="margin-top: 20px;font-size: 16px;">
          咖德蔚来诚邀全国各城市具备相关资源（如本地企业资源、安保团队基础、行业渠道）的合作伙伴，共同拓展区域安保市场，合作形式包括：
        </div>
        <div
          style="display: flex;justify-content: space-between;margin-top: 10px;"
        >
          <div class="modelBox">
            <div style="display: flex;justify-content: space-between;">
              <div class="jiao">
                <div style="font-weight: bold;font-size: 36px;">01</div>
                <div style="margin-top: 10px;font-weight: 600;">
                  合规协同合作
                </div>
              </div>
              <img
                src="../../../static/icon1.png"
                alt=""
                style="width: 40px;height: 40px;margin: 24px;"
              />
            </div>
            <div style="color: #7C8294;margin:0 20px;font-size: 14px;">
              配合地方安防工作部署，推动安保服务与公共安全防控协同推进
            </div>
          </div>
          <div class="modelBox">
            <div style="display: flex;justify-content: space-between;">
              <div class="jiao">
                <div style="font-weight: bold;font-size: 36px;">02</div>
                <div style="margin-top: 10px;font-weight: 600;">
                  区域独家合作伙伴
                </div>
              </div>
              <img
                src="../../../static/icon1.png"
                alt=""
                style="width: 40px;height: 40px;margin: 24px;"
              />
            </div>
            <div style="color: #7C8294;margin:0 20px;font-size: 14px;">
              负责指定城市 / 区域的业务拓展、客户维护
            </div>
          </div>
          <div class="modelBox">
            <div style="display: flex;justify-content: space-between;">
              <div class="jiao">
                <div style="font-weight: bold;font-size: 36px;">03</div>
                <div style="margin-top: 10px;font-weight: 600;">项目合作商</div>
              </div>
              <img
                src="../../../static/icon1.png"
                alt=""
                style="width: 40px;height: 40px;margin: 24px;"
              />
            </div>
            <div style="color: #7C8294;margin:0 20px;font-size: 14px;">
              针对具体行业客户或大型项目开展联合服务，共享收益
            </div>
          </div>
        </div>
        <div style="margin-top: 30px; margin-bottom: 20px; color: #070D2F;">
          咖德蔚来提供资源：
        </div>
        <div
          style="display: flex;justify-content: space-between;margin-top: 10px;"
        >
          <div class="modelBox1">
            <img
              src="../../../static/icon2.png"
              alt=""
              style="width: 32px;height: 32px;margin-right: 16px;"
            />
            <div>全流程的合作支撑（产品、技术、方案、谈判等）</div>
          </div>
          <div class="modelBox1">
            <img
              src="../../../static/icon2.png"
              alt=""
              style="width: 32px;height: 32px;margin-right: 16px"
            />
            <div>市场化合作收益分成</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <pageleft></pageleft> -->
    <pagebottom></pagebottom>
  </div>
</template>
<script>
import pageTop from "../../components/pageTitle.vue";
import pageleft from "../../components/leftCode.vue";
import pagebottom from "../../components/pagebottom.vue";
import swiper from "../../components/swiper.vue";
import swiper1 from "../../components/swiper1.vue";
export default {
  components: {
    pageTop,
    pageleft,
    swiper,
    swiper1,
    pagebottom
  },
  data() {
    return {
      bannerList: [],
      dialogTableVisible: false,
      selectItemVal: "",
      list: [
        {
          img: "../../../static/app.jpg",
          name: "服务实时定位，目所能及",
          icon: "../../../static/indexIcon1.png",
          icon1: "../../../static/indexIcon1-1.png"
        },
        {
          img: "../../../static/app1.png",
          name: "保安上岗平台认证，可靠放心",
          icon: "../../../static/indexIcon2.png",
          icon1: "../../../static/indexIcon2-2.png"
        },
        {
          img: "../../../static/app2.png",
          name: "需求自定义，随用随到",
          icon: "../../../static/indexIcon3.png",
          icon1: "../../../static/indexIcon3-3.png"
        },
        {
          img: "../../../static/app3.png",
          name: "智能管理，一手掌握",
          icon: "../../../static/indexIcon4.png",
          icon1: "../../../static/indexIcon4-4.png"
        }
      ],
      list1: [
        {
          img: "../../../static/app8.png",
          name: "零门槛护成长",
          icon: "../../../static/indexIcon5.png",
          icon1: "../../../static/indexIcon5-5.png"
        },
        {
          img: "../../../static/app5.png",
          name: "高薪岗位，靠谱",
          icon: "../../../static/indexIcon6.png",
          icon1: "../../../static/indexIcon6-6.png"
        },
        {
          img: "../../../static/app6.png",
          name: "行业专家培训",
          icon: "../../../static/indexIcon7.png",
          icon1: "../../../static/indexIcon7-7.png"
        },
        {
          img: "../../../static/app7.png",
          name: "业务智能提醒",
          icon: "../../../static/indexIcon8.png",
          icon1: "../../../static/indexIcon8-8.png"
        }
      ],
      active: 0,
      bgcolor: 1,
      bgcolorstring: "#fff",
      arr1: [
        {
          img: "../../static/1-1@2x.png",
          title: "构建警保协同全业务闭环",
          desc:
            "公安端八级联动可视指挥，管理端统筹审核，保安端移动上报，形成全流程闭环。"
        },
        {
          img: "../../static/1-2@2x.png",
          title: "全域可视与地图管",
          desc:
            "五级缩放管控点位，实时同步在岗状态，覆盖企业、项目、人员核心图层。"
        },
        {
          img: "../../static/1-3@2x.png",
          title: "实时联动通信",
          desc:
            "多元音视频通话，支持群呼与紧急优先通道，自动留存记录，保障快速响应。"
        },
        {
          img: "../../static/1-4@2x.png",
          title: "精准任务派发与闭环",
          desc:
            "多模板任务精准派发，状态预警，多媒体反馈归档，实现派发到审核闭环。"
        },
        {
          img: "../../static/1-5@2x.png",
          title: "信息推送",
          desc:
            "政策通缉令等富文本按层级推送，追踪已读未读，自动归档，合规发布。"
        }
      ],
      arr2: [
        {
          img: "../../static/2-1@2x.png",
          title: "安保数智化管控",
          desc: "事前资质预审、事中GIS调度、事后档案复盘，开展服务商信用监管。"
        },
        {
          img: "../../static/2-2@2x.png",
          title: "保安人员预审",
          desc:
            "对接官方数据接口，批量核查人员，生成电子台账与合规报告，提升审批效率。"
        },
        {
          img: "../../static/2-3@2x.png",
          title: "安保勤务数字化调度",
          desc:
            "大型活动安保指挥中枢，GIS全域感知，智能排班，突发事件一键闭环处置。"
        },
        {
          img: "../../static/2-4@2x.png",
          title: "突发事件闭环处置",
          desc: "移动端上报事件，指挥端地图派单，全流程留痕，音视频存档可复盘。"
        },
        {
          img: "../../static/2-5@2x.png",
          title: "多终端视频协同",
          desc: "支持多方视频会议，调取一线画面，消息强制置顶，追踪已读必达。"
        }
      ],
      arr3: [
        {
          img: "../../static/3-1@2x.png",
          title: "保安管理",
          desc: "电子花名册管理保安档案，一键指派项目，动态监控在职离职等状态。"
        },
        {
          img: "../../static/3-2@2x.png",
          title: "考勤管理",
          desc: "地理围栏定点考勤，异常预警，防作弊，解决在岗状态难核实问题。"
        },
        {
          img: "../../static/3-3@2x.png",
          title: "项目管理",
          desc: "项目地图标注点位，统一档案，总部穿透查看各项目运行与人员配置。"
        },
        {
          img: "../../static/3-4@2x.png",
          title: "事件管理",
          desc: "一线上报事件，后台调度处置，形成上报到归档闭环，留存证据。"
        },
        {
          img: "../../static/3-5@2x.png",
          title: "通知与工资管理",
          desc: "后台统一发布通知直达移动端，考勤自动核算薪资，减少人工出错。"
        }
      ],
      arr4: [
        {
          img: "../../static/4-5@2x.png",
          title: "培训/钱包/实名认证",
          desc: "线上课程赋能技能，邀请奖励拓展收益，实名认证降低用工风险。"
        },
        {
          img: "../../static/4-1@2x.png",
          title: "职位发布与管理",
          desc: "职位全流程管理，内置IM即时通讯，实现招聘高效对接。"
        },
        {
          img: "../../static/4-2@2x.png",
          title: "消息管理",
          desc: "IM聊天打通企业与保安，支持语音快捷回复，边聊边审简历。"
        },
        {
          img: "../../static/4-3@2x.png",
          title: "用户中心增值管理",
          desc: "AI智能匹配保安资源，数据看板优化招聘，支持发票申请与奖励提现。"
        },
        {
          img: "../../static/4-4@2x.png",
          title: "职位列表与筛选",
          desc: "汇聚用工需求，按周期性质分类，LBS推荐就近岗位，提升匹配体验。"
        }
      ],
      arr5: [
        {
          img: "../../static/4-1.png"
        },
        {
          img: "../../static/4-2.png"
        },
        {
          img: "../../static/4-3.png"
        },
        {
          img: "../../static/4-4.png"
        },
        {
          img: "../../static/4-5.png"
        }
      ]
    };
  },
  beforeUnmount() {
    // 移除事件监听（避免内存泄漏）
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    // 绑定滚动事件
    window.addEventListener("scroll", this.handleScroll);
    // 初始化时也获取一次
    this.handleScroll();
  },
  created() {
    this.bannerList = this.list;
  },
  methods: {
    handleScroll() {
      // 兼容性写法（现代浏览器一般直接用 window.pageYOffset 即可）
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 10) {
        this.bgcolor = 0;
        this.bgcolorstring = "#000";
      } else {
        this.bgcolor = 1;
        this.bgcolorstring = "#fff";
      }
    },
    handel(row) {
      if (row == "next") {
        this.$nextTick(() => {
          this.$refs.carousel.next();
        });
      } else {
        this.$nextTick(() => {
          this.$refs.carousel.prev();
        });
      }
    },
    selectList(val) {
      if (val == 0) {
        this.bannerList = this.list;
      } else {
        this.bannerList = this.list1;
      }
      this.active = val;
    },
    selectItem(val) {
      this.selectItemVal = val;
    }
  }
};
</script>
<style scoped>
/* .yinyin {
  position: absolute;
  top: 140px;
  left: 1100px;
  width: 149px;
  height: 314px;
  background: linear-gradient(
    100deg,
    rgba(255, 255, 255, 255) 0%,
    #fafcff 100%
  );
  z-index: 99;
} */
.modelBox1 {
  width: 562px;
  height: 80px;
  background: linear-gradient(
    180deg,
    #f0f5ff 1.98%,
    #fafcfe 74.29%,
    #fefeff 100%
  );
  box-shadow: 0px 2px 25px 0px rgba(27, 51, 112, 0.1);
  border-radius: 8px;
  border: 2px solid #ffffff;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  padding: 20px 20px;
  box-sizing: border-box;
}
.jiao {
  width: 226px;
  height: 110px;
  background-image: url("../../../static/yinyin.png");
  background-size: 100% 100%;
  padding: 20px 20px;
  box-sizing: border-box;
}
.modelBox {
  width: 375px;
  height: 170px;
  margin-top: 20px;
  background: #ffffff;
  box-shadow: 0px 5px 11px 0px rgba(115, 119, 133, 0.1);
  border-radius: 8px;
}
.qiye {
  width: 1200px;
  height: 509px;
  margin: 0 auto;
  background-image: url("../../../static/qiyeBg.png");
  background-size: 100% 100%;
  padding: 30px 24px;
  box-sizing: border-box;
  margin-bottom: 60px;
}
.bigBg {
  width: 100%;
  background-image: url("../../../static/modelBg.png");
  background-size: 100% 100%;
  padding: 10px 0;
  box-sizing: border-box;
}
.bottonBg {
  width: 100%;
  background-image: url("../../../static/bottonBg.png");
  background-size: 100% 100%;
  padding: 10px 0;
  box-sizing: border-box;
  margin-top: 30px;
}
.down-semicircle {
  width: 440px;
  height: 200px;
  position: relative;
  overflow: hidden;
  margin: 6px auto;
  display: none;
  position: absolute;
  top: 30px;
  left: 30%;
}

.down-semicircle::before {
  content: "";
  position: absolute;
  width: 440px;
  height: 350px;
  background: #fff;
  border-radius: 50%;
  top: -200px;
  left: 0;
  z-index: 99;
}
.downloadApp {
  color: #363b4d;
  font-size: 16px;
  margin-top: 10px;
  cursor: pointer;
  display: inline-block;
}
.downUser {
  width: 94px;
  height: 94px;
  position: absolute;
  top: 50px;
  left: 45%;
  z-index: 9999;
  display: none;
}
.downText {
  position: absolute;
  top: 150px;
  left: 45%;
  z-index: 9999;
  display: none;
  font-size: 12px;
}
.downloadApp:hover {
  color: #1677ff;
}
.downloadApp:hover + .down-semicircle {
  display: block;
}
.downloadApp:hover + .down-semicircle + .downUser {
  display: block;
}
.downloadApp:hover + .down-semicircle + .downUser + .downText {
  display: block;
}

.pageTop {
  width: 100%;
}
.activeBg {
  background: #fff;
  color: #000000 !important;
  box-shadow: 0px 2px 4px 0px rgba(155, 155, 155, 0.5);
}
.topContent {
  width: 604px;
  margin: 100px auto 0;
  text-align: center;
}
.contentTitle {
  font-size: 25px;
  font-weight: bold;
  color: #00122c;
  line-height: 29px;
}
.contentInfo {
  font-size: 13px;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
  margin-top: 12px;
  text-align: left;
}
.down {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 204px;
  font-size: 19px;
  font-weight: 500;
  color: #1677ff;
  line-height: 22px;
  position: relative;
  cursor: pointer;
}
.down img {
  width: 25px;
  height: 25px;
  margin-right: 11px;
}
.down:hover .bigImg {
  display: block;
}
.bigImg {
  width: 100px !important;
  height: 100px !important;
  position: absolute;
  top: 50px;
  left: 40%;
  display: none;
  z-index: 99999;
}
.itemBox {
  width: 1200px;
  margin: 40px auto;
  text-align: center;
}
.boxTitle {
  font-size: 25px;
  font-weight: bold;
  color: #00122c;
  line-height: 29px;
  display: flex;
  align-content: center;
  justify-content: center;
}
.boxTitle img {
  z-index: -1;
}
.boxTitle1 {
  width: 788px;
  font-size: 13px;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin: 12px auto 0;
}
.numBox {
  display: flex;
  justify-content: space-between;
  margin-top: 38px;
}
.numItem {
  width: 224px;
  height: 106px;
  background: #ffffff;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  border: 1px solid rgba(132, 182, 253, 0.4);
  padding: 25px 11px;
  font-size: 25px;
  font-weight: bold;
  color: #1677ff;
  display: flex;
  align-items: center;
  text-align: start;
  box-sizing: border-box;
}
.numItem img {
  width: 53px;
  height: 56px;
  margin-right: 10px;
  flex: none;
}
.solid {
  width: 100%;
  height: 1px;
  background: linear-gradient(
    to left,
    rgba(84, 245, 255, 0),
    #8fb7f4,
    rgba(84, 245, 255, 0)
  );
  margin-top: 63px;
}
.sweiperBox {
  width: 100%;
  display: flex;
  margin-top: 51px;
}
.sweiper {
  width: 300px;
  position: relative;
}
.el-carousel {
  width: 188px;
  height: 377px;
  margin-left: 68px;
  border: none !important;
}
.el-carousel__item {
  border: none !important;
}
.el-carousel__item img {
  width: 100%;
  height: 100%;
}
#left,
#right {
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin-top: -20px;
}
#left {
  position: absolute;
  top: 50%;
  left: 0;
}
#right {
  position: absolute;
  top: 50%;
  right: 0;
}
.listBox {
  margin-left: 73px;
  text-align: left;
  margin-top: 40px;
}
.listItem {
  width: 75px;
  height: 25px;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  border: 1px solid #1677ff;
  color: #1677ff;
  text-align: center;
  line-height: 25px;
  margin-right: 13px;
  font-size: 13px;
  cursor: pointer;
}
.listItemActive {
  color: #fff;
  border: none;
  background: #1677ff;
}
.listTitle {
  display: flex;
  margin-bottom: 20px;
}
.itemInfo {
  font-size: 13px;
  font-weight: 400;
  color: #000000;
  line-height: 13px;
  margin-top: 28px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.itemInfo:hover {
  font-size: 15px;
  font-weight: bold;
  color: #1677ff;
  line-height: 15px;
}
/* .itemInfo:hover .address {
  background: #1677ff;
} */
.address {
  margin-right: 10px;
  font-size: 13px;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  text-align: center;
  display: flex;
  align-items: center;
}
.img2 {
  width: 15px;
  height: 15px;
  margin-left: 8px;
}
.img1 {
  width: 31px;
  height: 31px;
}
.addressActive {
  background: rgba(22, 119, 255, 1);
  color: #fff;
}
.bannerActive {
  font-size: 15px;
  font-weight: bold;
  color: #1677ff;
  line-height: 15px;
}
.itemBox1 {
  width: 1200px;
  margin: 40px auto;
  text-align: center;
}
.case {
  width: 750px;
  margin: 0 auto 13px;
  display: flex;
  flex-wrap: wrap;
}
.caseItem {
  width: 163px;
  height: 105px;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  margin-right: 30px;
  margin-top: 25px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #333333;
  line-height: 21px;
  position: relative;
  cursor: pointer;
}
.caseItem:hover img {
  z-index: 5;
}
.caseItem img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -5;
}
.ccccc {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
}
.itemNmae {
  color: #fff;
  z-index: 2;
  line-height: 105px;
}

.caseItem:nth-child(4n) {
  margin-right: 0;
}
.cooperate {
  width: 750px;
  margin: 0 auto 53px;
  display: flex;
  flex-wrap: wrap;
}
.cooperateItem {
  width: 138px;
  height: 63px;
  background: #ffffff;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  margin-right: 14px;
  margin-top: 15px;
}
.cooperateItem:hover {
  box-shadow: 0px 0px 9px 0px rgba(106, 168, 255, 1);
}
.cooperateItem img {
  width: 100%;
  height: 100%;
}
.cooperateItem:nth-child(5n) {
  margin-right: 0;
}
</style>
<style>
.el-carousel__indicators--outside {
  display: none !important;
}
.el-carousel__container {
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/view/index/index.vue